
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

parcelRegister("lW4bD", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", function () { return $ff82431dc1dc3028$export$bdfd709ae4826697; }, function (v) { return $ff82431dc1dc3028$export$bdfd709ae4826697 = v; });
// TODO: convert this file to ESM once HMR issues are resolved
var $ff82431dc1dc3028$export$5a759dc7a1cfb72a;
var $ff82431dc1dc3028$export$bdfd709ae4826697;
var $ff82431dc1dc3028$export$c9e73fbda7da57b6;
"use strict";
const $ff82431dc1dc3028$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $ff82431dc1dc3028$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $ff82431dc1dc3028$var$getBundleURLCached(id, inputError) {
    let value = $ff82431dc1dc3028$var$bundleURL[id];
    if (!value) {
        value = $ff82431dc1dc3028$var$getBundleURL(inputError);
        $ff82431dc1dc3028$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $ff82431dc1dc3028$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $ff82431dc1dc3028$var$getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($ff82431dc1dc3028$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff82431dc1dc3028$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $ff82431dc1dc3028$var$getOrigin(url) {
    return new URL(url).origin;
}
$ff82431dc1dc3028$export$5a759dc7a1cfb72a = $ff82431dc1dc3028$var$getOrigin;
$ff82431dc1dc3028$export$bdfd709ae4826697 = $ff82431dc1dc3028$var$getBundleURLCached;
$ff82431dc1dc3028$export$c9e73fbda7da57b6 = $ff82431dc1dc3028$var$getBaseURL;

});

parcelRegister("9xKEy", function(module, exports) {
$parcel$export(module.exports, "ChatWidgetProvider", function () { return $c6548387155117f6$export$a4cac963ae9f34ca; });
$parcel$export(module.exports, "default", function () { return $c6548387155117f6$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jIe84 = parcelRequire("jIe84");
var $ac0eX = parcelRequire("ac0eX");
var $6NMje = parcelRequire("6NMje");
var $aCV3p = parcelRequire("aCV3p");

var $fuLgT = parcelRequire("fuLgT");

var $9dCmO = parcelRequire("9dCmO");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");

var $j2b52 = parcelRequire("j2b52");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $kEjoI = parcelRequire("kEjoI");

// Load omni-channel UI only on the client when widget is open to avoid SSR 503 (Tesseract)
const $c6548387155117f6$var$ChatWidgetOmniChannelUI = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("lNX8N")));

// Lazy-load analytics when fetchChatConnectionConfig succeeds (keeps @atlassian/omni-channel out of main bundle)
const $c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("asSV5")));

// Lazy-load analytics when fetchToken fails (same chunk as customer-joined analytics)
const $c6548387155117f6$var$ChatWidgetTokenErrorAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("asSV5")).then((m)=>({
            default: m.ChatWidgetTokenErrorAnalytics
        })));

// Lazy-load analytics when fetchChatConnectionConfig succeeds
const $c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("asSV5")).then((m)=>({
            default: m.ChatWidgetConnectionConfigSuccessAnalytics
        })));

// Lazy-load analytics when fetchToken succeeds (channelPlatformTokenError empty or null)
const $c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("asSV5")).then((m)=>({
            default: m.ChatWidgetTokenSuccessAnalytics
        })));
const $c6548387155117f6$export$8a240b2f27c2948f = (url)=>{
    try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname.replace(/\/+$/, "");
        if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
        return pathname.replace(/^\/+/, "");
    } catch (e) {
        const match = /\/\/[^/]+(\/[^#?]*)/.exec(url);
        if (match === null || match === void 0 ? void 0 : match[1]) {
            let pathname = match[1].replace(/\/+$/, "");
            if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
            return pathname.replace(/^\/+/, "");
        }
        return "";
    }
};
const $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH = {
    "software/jira/product-discovery": {
        contactFlowId: "4cdb6e29-9088-4404-bbfe-dfdba35bd3d6",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/jira": {
        contactFlowId: "7e776619-ede4-4975-a194-38c6b182fa0c",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom": {
        contactFlowId: "42cee94e-c0db-43d2-bd45-3cca9d7adb61",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-confluence": {
        contactFlowId: "9f1756b6-8607-43b4-97b6-32f888713bf0",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-jira": {
        contactFlowId: "863e7f31-092a-45c6-affa-02db50c7ef72",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/resources": {
        contactFlowId: "4b5e7c93-5e16-4479-8030-fcad737249a3",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/ai-meeting": {
        contactFlowId: "f1956561-00b8-4ee0-a6c2-2100d07feb5f",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/editing": {
        contactFlowId: "bc21d930-ac0d-4eec-9158-d2dde2097029",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/company/contact/japan": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/pricing": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence/pricing": {
        contactFlowId: "af93bfc1-9e6f-481b-bc07-834e30832ba6",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management/pricing": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    }
};
const $c6548387155117f6$export$a8ad7472af635967 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    var _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath;
    return (_CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath]) !== null && _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath !== void 0 ? _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath : {
        contactFlowId: ""
    };
};
const $c6548387155117f6$export$b28607ea792e8283 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && Array.isArray(entry.formKey)) return entry.formKey;
    return [
        ""
    ];
};
const $c6548387155117f6$export$39f87d2399b576ea = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && typeof entry.attributes === "object" && entry.attributes !== null) return JSON.stringify(entry.attributes, null, 2);
    return "{}";
};
const $c6548387155117f6$export$c452173f1b4082d7 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    return normalizedPath === "ja" || normalizedPath.startsWith("ja/");
};
const $c6548387155117f6$export$8378cdc69cfc311a = (url)=>{
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading and trailing slashes, then split by '/' and filter out empty strings
        const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
        // Join with underscores
        return pathParts.join("_");
    } catch (error) {
        // If URL parsing fails, try to extract path manually
        const match = /\/\/[^\/]+(\/[^?#]*)/.exec(url);
        if (match && match[1]) {
            const pathname = match[1];
            const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
            return pathParts.join("_");
        }
        return "";
    }
};
const $c6548387155117f6$export$2b66390f6eecea5c = (payload)=>{
    const transformed = {};
    if (!payload) return transformed;
    Object.entries(payload).forEach(([key, value])=>{
        // Skip attachments
        if (key === "attachments") return;
        // Skip null or undefined values
        if (value === null || value === undefined) return;
        // Handle arrays - normalize to array of strings
        if (Array.isArray(value)) transformed[key] = value.map((v)=>{
            // If array element is an object (like {userEmail: "value"}), extract the first value
            if (typeof v === "object" && v !== null && !Array.isArray(v)) {
                const firstValue = Object.values(v)[0];
                return firstValue !== undefined ? String(firstValue) : String(v);
            }
            // Already a string or primitive
            return String(v);
        });
        else transformed[key] = [
            String(value)
        ];
    });
    return transformed;
};
const $c6548387155117f6$export$a40d7197cc58cf92 = (payload)=>{
    return JSON.stringify(payload);
};
const $c6548387155117f6$export$6999922c2cdd8944 = (chatConnectionConfigResponse)=>{
    const submitRequest = chatConnectionConfigResponse === null || chatConnectionConfigResponse === void 0 ? void 0 : chatConnectionConfigResponse.channelPlatform_createContact;
    return {
        channelPlatform_submitRequest: submitRequest
    };
};
function $c6548387155117f6$export$c0c7c314cc68764f(config) {
    var _contact_value;
    const contact = config === null || config === void 0 ? void 0 : config.channelPlatform_createContact;
    return contact === null || contact === void 0 ? void 0 : (_contact_value = contact.value) === null || _contact_value === void 0 ? void 0 : _contact_value.contactId;
}
function $c6548387155117f6$export$f0671fd2506d780c(config) {
    const contact = config === null || config === void 0 ? void 0 : config.channelPlatform_createContact;
    const value = contact === null || contact === void 0 ? void 0 : contact.value;
    return {
        contactId: value === null || value === void 0 ? void 0 : value.contactId,
        participantId: value === null || value === void 0 ? void 0 : value.participantId,
        region: value === null || value === void 0 ? void 0 : value.region
    };
}
function $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail, isUserLoggedIn) {
    return {
        cst_support_forms_data_fieldDescMap: [
            '{"inquiry_category":"Inquiry Category","email":"Email","raised_obo_by":"Raised on behalf of by","language":"language","customer_working_hours":"Support Business Hours Select"}'
        ],
        customer_email: [
            isUserLoggedIn ? userEmail : ""
        ],
        authenticated: isUserLoggedIn ? null : [
            "No"
        ],
        email: [
            isUserLoggedIn ? userEmail : ""
        ],
        customer_status: [
            "Customer"
        ],
        cst_support_forms_data_formKey: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_formLabel: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_timezone: [
            "GMT+6"
        ],
        referral_url: [
            window.location.href
        ],
        language: [
            "en"
        ],
        is_partner_dc_exception: [
            "Customer not in SFDC"
        ],
        topic: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href)
        ],
        summary: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href).split("_").join(" ")
        ],
        support_channel: [
            "chat"
        ],
        inquiry_category: [
            "access_issues"
        ],
        cst_support_forms_data_contextId: [
            contextId
        ]
    };
}
function $c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasOpenCurrent, clientToken, clientWithToken) {
    return isWidgetOpen && !wasOpenCurrent && !!clientToken && !!clientWithToken;
}
function $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn) {
    return {
        flowId: $c6548387155117f6$export$a8ad7472af635967($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)).contactFlowId,
        formContext: {
            summary: [
                "Chat Transcript for <email removed for privacy>"
            ],
            details: "",
            contactEmail: isUserLoggedIn ? userEmail !== null && userEmail !== void 0 ? userEmail : "" : "",
            isAuthenticated: isUserLoggedIn
        }
    };
}
function $c6548387155117f6$var$hasCustomerConversations(response) {
    var _response_channelPlatform_getCustomerConversations_conversations, _response_channelPlatform_getCustomerConversations;
    var _response_channelPlatform_getCustomerConversations_conversations_length;
    const count = (_response_channelPlatform_getCustomerConversations_conversations_length = response === null || response === void 0 ? void 0 : (_response_channelPlatform_getCustomerConversations = response.channelPlatform_getCustomerConversations) === null || _response_channelPlatform_getCustomerConversations === void 0 ? void 0 : (_response_channelPlatform_getCustomerConversations_conversations = _response_channelPlatform_getCustomerConversations.conversations) === null || _response_channelPlatform_getCustomerConversations_conversations === void 0 ? void 0 : _response_channelPlatform_getCustomerConversations_conversations.length) !== null && _response_channelPlatform_getCustomerConversations_conversations_length !== void 0 ? _response_channelPlatform_getCustomerConversations_conversations_length : 0;
    return count > 0;
}
function $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded) {
    const isChatLoaded = isWidgetOpen && !!clientToken && !!chatConnectionConfig && isCustomerComponentLoaded;
    return {
        isChatLoaded: isChatLoaded,
        showFloatingButton: !isChatLoaded,
        isButtonLoading: isWidgetOpen && (!clientToken || !chatConnectionConfig || !isCustomerComponentLoaded)
    };
}
const $c6548387155117f6$var$ChatFloatingButton = ({ isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": isLoading ? "Loading chat" : "Open chat widget",
        style: {
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 1000,
            cursor: isLoading ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            backgroundColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            color: "white",
            boxShadow: (0, $lP7A9.default)("elevation.shadow.raised")
        },
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "medium",
            label: "Loading chat",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))), {
            label: "",
            size: "medium",
            color: "currentColor"
        })
    });
};
function $c6548387155117f6$var$useChatWidgetConnection({ isWidgetOpen: isWidgetOpen, contextId: contextId, userEmail: userEmail, isUserLoggedIn: isUserLoggedIn, setIsCustomerComponentLoaded: setIsCustomerComponentLoaded }) {
    const [clientToken, setClientToken] = (0, $1oC0p.useState)(null);
    const [chatConnectionConfig, setChatConnectionConfig] = (0, $1oC0p.useState)(null);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    const [channelPlatformTokenError, setChannelPlatformTokenError] = (0, $1oC0p.useState)(null);
    const [customerConversationsResponse, setCustomerConversationsResponse] = (0, $1oC0p.useState)(null);
    const generateAuthHeader = (channelsIdentityHash)=>new (0, $ac0eX.ApolloLink)((operation, forward)=>{
            operation.setContext(({ headers: headers = {} })=>({
                    headers: (0, $dPABA._)((0, $6ogO3._)({}, headers), {
                        "Content-Type": "application/json",
                        "X-Client-Hash": channelsIdentityHash
                    })
                }));
            return forward(operation);
        });
    const client = (0, $1oC0p.useMemo)(()=>{
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: link,
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, []);
    const wasWidgetOpenRef = (0, $1oC0p.useRef)(false);
    const clientWithToken = (0, $1oC0p.useMemo)(()=>{
        if (!clientToken) return null;
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: (0, $ac0eX.ApolloLink).from([
                generateAuthHeader(clientToken),
                link
            ]),
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, [
        clientToken
    ]);
    const isRefreshed = (0, $1oC0p.useMemo)(()=>$c6548387155117f6$var$hasCustomerConversations(customerConversationsResponse), [
        customerConversationsResponse
    ]);
    const fetchCustomerConversations = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) return;
        const anonymousId = (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "";
        clientWithToken.query({
            query: (0, $kEjoI.getCustomerConversations),
            variables: {
                anonymousId: anonymousId
            }
        }).then((response)=>{
            var _response_data;
            setCustomerConversationsResponse((_response_data = response === null || response === void 0 ? void 0 : response.data) !== null && _response_data !== void 0 ? _response_data : null);
        }).catch((err)=>{
            console.warn("Error fetching customer conversations:", err);
            setCustomerConversationsResponse(null);
        });
    }, [
        clientWithToken
    ]);
    const fetchChatConnectionConfig = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) {
            console.warn("Client with token not available yet");
            return;
        }
        setLoading(true);
        const formValues = $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail !== null && userEmail !== void 0 ? userEmail : "", isUserLoggedIn);
        var _JSON_parse;
        clientWithToken.query({
            query: (0, $kEjoI.getChatConnectionConfigForSalesChannel),
            variables: {
                requestType: "CHAT",
                payload: $c6548387155117f6$export$2b66390f6eecea5c(formValues),
                metadata: $c6548387155117f6$export$a40d7197cc58cf92($c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn)),
                attributes: (_JSON_parse = JSON.parse($c6548387155117f6$export$39f87d2399b576ea($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)))) !== null && _JSON_parse !== void 0 ? _JSON_parse : {},
                anonymousId: (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || ""
            }
        }).then((response)=>{
            setChatConnectionConfig(response === null || response === void 0 ? void 0 : response.data);
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching chat connection config:", err);
            setError(err);
            setLoading(false);
        });
    }, [
        clientWithToken,
        contextId,
        isUserLoggedIn,
        userEmail
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if ($c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasWidgetOpenRef.current, clientToken, clientWithToken)) {
            wasWidgetOpenRef.current = true;
            fetchCustomerConversations();
            fetchChatConnectionConfig();
        }
        if (!isWidgetOpen) {
            wasWidgetOpenRef.current = false;
            setIsCustomerComponentLoaded(false);
        }
    }, [
        isWidgetOpen,
        clientToken,
        clientWithToken,
        fetchCustomerConversations,
        fetchChatConnectionConfig,
        setIsCustomerComponentLoaded
    ]);
    const fetchToken = (0, $1oC0p.useCallback)(()=>{
        setLoading(true);
        client.query({
            query: (0, $kEjoI.getChannelPlatformTokenByClientName),
            variables: {
                clientName: "sales"
            }
        }).then((response)=>{
            var _response_data;
            const token = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.supportInquiry_channelsIdentityHashByClientName;
            if (token) {
                setClientToken(token);
                setChannelPlatformTokenError(null);
            }
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching channel platform token:", err);
            setError(err);
            setLoading(false);
            const errorMessage = err instanceof Error ? err.message : String(err);
            setChannelPlatformTokenError(errorMessage);
        });
    }, [
        client
    ]);
    return {
        clientToken: clientToken,
        chatConnectionConfig: chatConnectionConfig,
        loading: loading,
        error: error,
        channelPlatformTokenError: channelPlatformTokenError,
        client: client,
        clientWithToken: clientWithToken,
        isRefreshed: isRefreshed,
        customerConversationsResponse: customerConversationsResponse,
        setClientToken: setClientToken,
        fetchToken: fetchToken
    };
}
const $c6548387155117f6$export$a4cac963ae9f34ca = ({ children: children })=>{
    const [isWidgetOpen, setIsWidgetOpen] = (0, $1oC0p.useState)(false);
    const [isCustomerComponentLoaded, setIsCustomerComponentLoaded] = (0, $1oC0p.useState)(false);
    const { accountId: aaid, email: userEmail, isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const contextId = (0, $1oC0p.useMemo)(()=>(0, $fuLgT.default)(), []);
    const connection = $c6548387155117f6$var$useChatWidgetConnection({
        isWidgetOpen: isWidgetOpen,
        contextId: contextId,
        userEmail: userEmail,
        isUserLoggedIn: isUserLoggedIn,
        setIsCustomerComponentLoaded: setIsCustomerComponentLoaded
    });
    const { clientToken: clientToken, chatConnectionConfig: chatConnectionConfig, loading: loading, error: error, channelPlatformTokenError: channelPlatformTokenError, isRefreshed: isRefreshed, customerConversationsResponse: customerConversationsResponse } = connection;
    const surveyModalAttributes = {
        width: "80%",
        height: 500
    };
    const omniChannelEnv = "staging";
    const handleChatButtonClick = ()=>{
        const opening = !isWidgetOpen;
        setIsWidgetOpen(opening);
        if (opening) connection.fetchToken();
    };
    const handleChatButtonKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleChatButtonClick();
        }
    };
    const viewState = $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded);
    const showChatPanel = isWidgetOpen && !!chatConnectionConfig && !!clientToken;
    const conversationId = $c6548387155117f6$export$c0c7c314cc68764f(chatConnectionConfig);
    const connectionConfigAttributes = $c6548387155117f6$export$f0671fd2506d780c(chatConnectionConfig);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                children,
                chatConnectionConfig && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics, {
                            conversationId: conversationId
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics, {
                            contactId: connectionConfigAttributes.contactId,
                            participantId: connectionConfigAttributes.participantId,
                            region: connectionConfigAttributes.region
                        })
                    ]
                }),
                channelPlatformTokenError && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenErrorAnalytics, {
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                clientToken && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics, {
                        clientToken: clientToken,
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                viewState.showFloatingButton && /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatFloatingButton, {
                    isLoading: viewState.isButtonLoading,
                    onClick: handleChatButtonClick,
                    onKeyDown: handleChatButtonKeyDown
                }),
                showChatPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetOmniChannelUI, {
                        env: omniChannelEnv,
                        clientIdentityHash: clientToken || "",
                        chatContactDetails: $c6548387155117f6$export$6999922c2cdd8944(chatConnectionConfig),
                        accountId: aaid || "",
                        isRefreshed: isRefreshed,
                        customerConversations: customerConversationsResponse,
                        loading: loading,
                        error: error,
                        isUserLoggedIn: isUserLoggedIn,
                        surveyModalAttributes: surveyModalAttributes,
                        onLoaded: ()=>setIsCustomerComponentLoaded(true)
                    })
                })
            ]
        })
    });
};
var $c6548387155117f6$export$2e2bcd8739ae039 = $c6548387155117f6$export$a4cac963ae9f34ca;

});
parcelRegister("kEjoI", function(module, exports) {
$parcel$export(module.exports, "getChatConnectionConfigForSalesChannel", function () { return $59b9792633dffc77$export$2fedc4b0d22f20b3; });
$parcel$export(module.exports, "getCustomerConversations", function () { return $59b9792633dffc77$export$54e9b7f1aad2199a; });
$parcel$export(module.exports, "getChannelPlatformTokenByClientName", function () { return $59b9792633dffc77$export$c543cd67c9b21e36; });
// @ts-expect-error - @apollo/client is ESM but this file is treated as CommonJS by TypeScript

var $4Wqet = parcelRequire("4Wqet");
let $59b9792633dffc77$var$_ = (t)=>t, $59b9792633dffc77$var$t, $59b9792633dffc77$var$t1, $59b9792633dffc77$var$t2, $59b9792633dffc77$var$t3, $59b9792633dffc77$var$t4;
const $59b9792633dffc77$export$51e62cbd534f416c = (0, $4Wqet.gql)($59b9792633dffc77$var$t || ($59b9792633dffc77$var$t = $59b9792633dffc77$var$_`
    query channelPlatformTokenGeneration {
        supportInquiry_channelsIdentityHash
    }
`));
const $59b9792633dffc77$export$2fedc4b0d22f20b3 = (0, $4Wqet.gql)($59b9792633dffc77$var$t1 || ($59b9792633dffc77$var$t1 = $59b9792633dffc77$var$_`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
        $anonymousId: String
        $attributes: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: {
                payload: $payload
                metadata: $metadata
                attributes: $attributes
            }
            anonymousId: $anonymousId
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`));
const $59b9792633dffc77$export$54e9b7f1aad2199a = (0, $4Wqet.gql)($59b9792633dffc77$var$t2 || ($59b9792633dffc77$var$t2 = $59b9792633dffc77$var$_`
    query CustomerConversations($anonymousId: String) {
        channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
            conversations
        }
    }
`));
const $59b9792633dffc77$export$f843774d31ce9c0c = (0, $4Wqet.gql)($59b9792633dffc77$var$t3 || ($59b9792633dffc77$var$t3 = $59b9792633dffc77$var$_`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: { payload: $payload, metadata: $metadata }
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`));
const $59b9792633dffc77$export$c543cd67c9b21e36 = (0, $4Wqet.gql)($59b9792633dffc77$var$t4 || ($59b9792633dffc77$var$t4 = $59b9792633dffc77$var$_`
    query channelPlatformTokenGenerationByClientName($clientName: String) {
        supportInquiry_channelsIdentityHashByClientName(
            request: { clientName: $clientName }
        )
    }
`));

});

parcelRegister("lNX8N", function(module, exports) {


























module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("1UZeW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("iWCiw")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("eDmkW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gjBTD")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("2TJ5h")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("fpTAo")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("j2nJQ")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("6zKN2")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("HRjDP")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("9WEDO")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gFcxC")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("7Q4ht")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("76kmj"))
]).then(()=>parcelRequire('8Cs4z'));

});
parcelRegister("1athW", function(module, exports) {
"use strict";

var $1tHQt = parcelRequire("1tHQt");
module.exports = $1tHQt(function importModule(bundle) {
    return new Promise((resolve, reject)=>{
        // Add a global function to handle when the script loads.
        let globalName = `i${('' + Math.random()).slice(2)}`;
        $parcel$global[globalName] = (m)=>{
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        let cleanup = ()=>{
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        let script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = `import * as m from '${bundle}'; ${globalName}(m);`;
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("1tHQt", function(module, exports) {
"use strict";
let $113a82a87c54a561$var$cachedBundles = {};
let $113a82a87c54a561$var$cachedPreloads = {};
let $113a82a87c54a561$var$cachedPrefetches = {};
function $113a82a87c54a561$var$getCache(type) {
    switch(type){
        case 'preload':
            return $113a82a87c54a561$var$cachedPreloads;
        case 'prefetch':
            return $113a82a87c54a561$var$cachedPrefetches;
        default:
            return $113a82a87c54a561$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $113a82a87c54a561$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("asSV5", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("1UZeW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("iWCiw")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hx68B"))
]).then(()=>parcelRequire('cJIcN'));

});


var $caa2d1ec6170a160$exports = {};


(parcelRequire("hwrhg")).register((parcelRequire("lW4bD")).getBundleURL('7riGl'), JSON.parse("[\"7riGl\",\"jira-product-discovery-page.0a9eb167.js\",\"76kmj\",\"chat-widget-omni-channel-ui.de1c2110.js\",\"6Hc2y\",\"modal.a0df79e8.js\",\"1Etsc\",\"embedCard.e53430e5.js\",\"847Vz\",\"datasourceTableView.83d5a5a3.js\",\"hdFVX\",\"custom-theme.94889777.js\",\"7gQUy\",\"atlassian-light.f6855285.js\",\"8PkqS\",\"atlassian-light-future.d2d475ae.js\",\"d1UJM\",\"atlassian-light-increased-contrast.ce17cf20.js\",\"5zUWn\",\"atlassian-dark.c450a567.js\",\"bi7iI\",\"atlassian-dark-future.d4c5c6db.js\",\"8cEoG\",\"atlassian-dark-increased-contrast.e269a439.js\",\"gJjFX\",\"atlassian-legacy-light.d764f209.js\",\"ec8ot\",\"atlassian-legacy-dark.ff2f0f75.js\",\"165OO\",\"atlassian-spacing.7ba49ffd.js\",\"enFem\",\"atlassian-typography.d98fc739.js\",\"ekp1O\",\"atlassian-typography-adg3.76200f79.js\",\"cFJQy\",\"atlassian-shape.81c57cdf.js\",\"6oWPm\",\"atlassian-typography-modernized.af7f5620.js\",\"frMLF\",\"atlassian-typography-refreshed.69397c98.js\",\"j7ZNh\",\"atlassian-light-brand-refresh.78becf65.js\",\"c7cUo\",\"atlassian-dark-brand-refresh.c950e57b.js\",\"bHEL0\",\"datasourceTableView.6a406b69.js\",\"2wTbi\",\"modal.bb810295.js\",\"eWe64\",\"modal.651f7fbd.js\",\"iCZTw\",\"dark.16cc06e7.svg\",\"eVZsY\",\"light.e350f7db.svg\",\"8f4hZ\",\"dark.981334ac.svg\",\"kydQZ\",\"light.d61b1f64.svg\",\"32OrT\",\"custom-theme.0d65613d.js\",\"lExK6\",\"atlassian-light.f74e53e5.js\",\"63th3\",\"atlassian-light-future.e2082828.js\",\"guCS1\",\"atlassian-light-increased-contrast.d8df2fa9.js\",\"2tX9S\",\"atlassian-dark.91d3f681.js\",\"zUvum\",\"atlassian-dark-future.778441d5.js\",\"2PhFQ\",\"atlassian-dark-increased-contrast.3b3509e9.js\",\"jDzBC\",\"atlassian-legacy-light.46a7a55a.js\",\"grs0i\",\"atlassian-legacy-dark.a7f8e127.js\",\"91NZ1\",\"atlassian-spacing.e85f99d1.js\",\"033DE\",\"atlassian-typography.d12a336a.js\",\"7lg1U\",\"atlassian-shape.e955d191.js\",\"lzCLl\",\"dark.90199792.svg\",\"8quzl\",\"light.5ffcf568.svg\",\"liGvy\",\"component-lazy.3e601b41.js\",\"aXHfO\",\"file-icon.3e4cfcf7.js\",\"8Gud5\",\"chart-bar-icon.7695d967.js\",\"9rbe5\",\"list-bullet-icon.8e252085.js\",\"8DwmE\",\"embedCard.65be0128.js\",\"hc6ft\",\"file--document-filled.092364a5.js\",\"gAaTd\",\"people-group.039507d3.js\",\"9yG1J\",\"16.00e6166a.js\",\"8hdJi\",\"16.70320893.js\",\"8EkaQ\",\"16.06a15e5b.js\",\"ea9vx\",\"16.48c10156.js\",\"2DITZ\",\"16.5addfcab.js\",\"9ysOW\",\"16.dd414cf6.js\",\"d3VeM\",\"16.f006e00e.js\",\"f185M\",\"16.7f65859d.js\",\"bP6QH\",\"16.b29173ee.js\",\"iIiz1\",\"16.bfab01a6.js\",\"jlnZV\",\"16.f752a6e3.js\",\"49rYz\",\"16.5c127ccc.js\",\"f5THM\",\"16.89261912.js\",\"fS5aw\",\"component-lazy.8645f3ba.js\",\"cNqyk\",\"custom-theme.dcc613c3.js\",\"67G18\",\"atlassian-light.9a2836f8.js\",\"9aHW1\",\"atlassian-light-future.c2ace348.js\",\"58YkL\",\"atlassian-light-increased-contrast.b9e6064d.js\",\"lYtLB\",\"atlassian-dark.89800bf3.js\",\"hN1k8\",\"atlassian-dark-future.fb752ac0.js\",\"2vgig\",\"atlassian-dark-increased-contrast.56f27f0b.js\",\"2Z9sD\",\"atlassian-legacy-light.d5f12d8d.js\",\"6Z3Ag\",\"atlassian-legacy-dark.c654331e.js\",\"7sysd\",\"atlassian-spacing.6f7c19eb.js\",\"4lKL9\",\"atlassian-typography.f3d4c687.js\",\"2LUz0\",\"atlassian-typography-adg3.63863a99.js\",\"aDLAv\",\"atlassian-shape.ed3ef6fd.js\",\"l7WJj\",\"atlassian-shape-rounder.2d44ad6e.js\",\"9qg9C\",\"atlassian-shape-roundest.e20e0583.js\",\"8Xrqp\",\"atlassian-typography-modernized.a8eed6fd.js\",\"aJe4E\",\"atlassian-typography-refreshed.12e5698a.js\",\"ZOcdO\",\"atlassian-light-brand-refresh.115fc324.js\",\"d7t6F\",\"atlassian-dark-brand-refresh.001f44e8.js\",\"bTaOO\",\"audio-icon.9b33b2e6.js\",\"jkouq\",\"angle-brackets-icon.bb60b2fa.js\",\"eyGRK\",\"folder-icon.5525d149.js\",\"90sX7\",\"image-icon.71d6845f.js\",\"kCVhd\",\"video-icon.80835bd0.js\",\"2E2HA\",\"lock-locked--lock-filled.d88937c1.js\",\"lRI2Y\",\"16.dca930e1.js\",\"fWWE5\",\"24.c4c66b57.js\",\"8o7Ts\",\"16.79b3c66f.js\",\"cFvqv\",\"24.ab1a9007.js\",\"eOvUw\",\"16.c7829381.js\",\"nm140\",\"24.2a4a3a90.js\",\"6CuKg\",\"16.39bb40b0.js\",\"k9hlb\",\"24.b1278276.js\",\"8G5eK\",\"16.90c689b8.js\",\"9ri2N\",\"24.071d0bb9.js\",\"93J0M\",\"16.21cc8616.js\",\"lrPIC\",\"24.e6fe156f.js\",\"58qCs\",\"16.06c8593a.js\",\"kZbQK\",\"24.75483431.js\",\"lgPBh\",\"16.1ae8d110.js\",\"iZF5R\",\"24.75fedb41.js\",\"8I81U\",\"16.d25db2a1.js\",\"hT09x\",\"24.4b2d370c.js\",\"cwE10\",\"16.7109a405.js\",\"aCrGD\",\"24.c0635586.js\",\"8HMJx\",\"16.0b2cbddf.js\",\"dvNrH\",\"24.62dc4b32.js\",\"9lj4x\",\"16.1cc466c4.js\",\"jtSYT\",\"24.945cd5c9.js\",\"cxK3I\",\"24.ab563540.js\",\"dPh4e\",\"24.612703e3.js\",\"9YeU5\",\"24.aeae6a01.js\",\"6plOw\",\"24.a13f6a1c.js\",\"6NidY\",\"24.5146812d.js\",\"e0eIk\",\"24.337e1819.js\",\"95LIj\",\"24.4633ea94.js\",\"adbKr\",\"24.8872c80f.js\",\"d6tGh\",\"24.1ef2c0a2.js\",\"iefvr\",\"24.d46c71d8.js\",\"kPBg6\",\"24.3653050f.js\",\"kA9tL\",\"24.d1d4e5d5.js\",\"4SXK0\",\"24.92c524d2.js\",\"Sydd2\",\"confluence-icon.06c496d3.js\",\"cKgik\",\"jira-icon.2a991029.js\",\"lib95\",\"attachment.bff81132.js\",\"D5ka0\",\"task.22efb3bf.js\",\"dXvbQ\",\"component.018a2193.js\",\"1A6ym\",\"comment.ee377497.js\",\"8CMvx\",\"eye-open--watch.737f72b7.js\",\"9dm3d\",\"thumbs-up--like.6f94fcbb.js\",\"4zav0\",\"arrow-up.9c4c227c.js\",\"l9PCY\",\"priority-blocker.16e3a114.js\",\"lRtmg\",\"priority-critical.5f6443c1.js\",\"4lNLt\",\"priority-high.6a2275b6.js\",\"2oyYc\",\"priority-highest.a863a382.js\",\"i4dsq\",\"priority-low.6b413bbb.js\",\"lD1Rq\",\"priority-lowest.e8f96cd5.js\",\"bgSXd\",\"priority-major.a803d808.js\",\"8z8vC\",\"priority-medium.6d05777b.js\",\"aEXtk\",\"priority-minor.867e56ec.js\",\"ck942\",\"priority-trivial.6aec4aeb.js\",\"e425q\",\"question-circle--question.e4e7bca5.js\",\"5rsU4\",\"angle-brackets--code.09df0e4f.js\",\"1pVQO\",\"people-group--people.ce56c390.js\",\"1ucEX\",\"subtasks--subtask.da75dd18.js\",\"UxexI\",\"goal-icon.39e991fa.js\",\"6nPL4\",\"projects-icon.d21d8402.js\",\"y6CTt\",\"manual-triggers-modal.957079b6.js\",\"jUgWl\",\"RelatedLinksModal.6546010f.js\",\"iRXom\",\"EmbedModal.7b493850.js\",\"c6370\",\"modal.7589e7d7.js\",\"5NarU\",\"standard.6c3cc6ed.svg\",\"8qrss\",\"modal.f1a21e7d.js\",\"gVnQ5\",\"modal.72667a69.js\",\"i6I8C\",\"modal.eb0e7e6c.js\",\"fuVyY\",\"modal.dbbc5c85.js\",\"6glGi\",\"dark.725705dc.svg\",\"f3gSE\",\"light.bf58aa10.svg\",\"dDNE6\",\"modal.21d0ed8f.js\",\"kYefW\",\"ParseTreePatternMatcher.d7254574.js\",\"axKjy\",\"atlassian-light.b4ee2612.js\",\"fKwGe\",\"atlassian-light-future.b5adf01e.js\",\"eDQ9x\",\"atlassian-light-increased-contrast.09be1aaf.js\",\"7q0ad\",\"atlassian-dark.1392cd06.js\",\"4EQ5p\",\"atlassian-dark-future.f6a09727.js\",\"1QNh5\",\"atlassian-dark-increased-contrast.00b01498.js\",\"9hgng\",\"atlassian-legacy-light.dec9b130.js\",\"6UfG0\",\"atlassian-legacy-dark.33bd99fc.js\",\"32081\",\"atlassian-spacing.b6c6e0e8.js\",\"a32QV\",\"atlassian-typography.bf73aaf2.js\",\"8AoS1\",\"atlassian-shape.99d2c5e5.js\",\"9zCJ4\",\"custom-theme.1c47b726.js\",\"fpTAo\",\"modal.7f7441dc.js\",\"k0cqj\",\"esm.a2102746.js\",\"4hdf6\",\"action.ce0661be.js\",\"9Nq5w\",\"code.f22a761d.js\",\"ePGFA\",\"date.58dcf549.js\",\"991q1\",\"decision.4938a905.js\",\"kLC4B\",\"divider.896b8d75.js\",\"hvmJX\",\"emoji.56f63c8b.js\",\"cEmjT\",\"images.f4698726.js\",\"fOVzu\",\"layout.3d222d87.js\",\"a0uE3\",\"link.be47e6ba.js\",\"csXda\",\"list-number.10cd8f27.js\",\"3IfvT\",\"list.628117b7.js\",\"fRMbE\",\"mention.54867f30.js\",\"1enB6\",\"panel-error.dd26580d.js\",\"7RpMt\",\"panel-note.4ef15d88.js\",\"3pgks\",\"panel-success.7dc4eedd.js\",\"6l9qM\",\"panel-warning.d527ac7a.js\",\"4Hqzu\",\"panel.1de4f121.js\",\"ktPG4\",\"quote.2e1cbbb7.js\",\"k7byj\",\"status.39ceb906.js\",\"YF1xP\",\"one-column-layout.cba9191e.js\",\"2oceX\",\"two-column-layout.c59ed84b.js\",\"6DvU4\",\"three-column-layout.834d3e87.js\",\"d024f\",\"four-column-layout.976464ce.js\",\"eWrXe\",\"five-column-layout.37c22033.js\",\"89orV\",\"feedback.2c34e6bc.js\",\"dg3wD\",\"expand.4d94e76a.js\",\"gWJBp\",\"datasource-jira-issue.fdd78a56.js\",\"4bbFn\",\"datasource-assets-objects.b1340a05.js\",\"dmUiG\",\"datasource-confluence-search.711a2c48.js\",\"401Wt\",\"loom.eaa5ef4d.js\",\"cXmQo\",\"syncBlock.75443c1b.js\",\"jQbh8\",\"atlassian-light.8bd65ee1.js\",\"1zC8Y\",\"atlassian-light-future.d53424c5.js\",\"1FHfC\",\"atlassian-light-increased-contrast.01726165.js\",\"8BrUz\",\"atlassian-dark.ce952ca9.js\",\"d6NiB\",\"atlassian-dark-future.4c6da23f.js\",\"lnRPn\",\"atlassian-dark-increased-contrast.7ab6edd6.js\",\"cBs7P\",\"atlassian-legacy-light.22aab30c.js\",\"aYkZC\",\"atlassian-legacy-dark.f44e65c6.js\",\"bs7MW\",\"atlassian-spacing.a3a3a4a8.js\",\"dmula\",\"atlassian-typography.9686ccda.js\",\"cqbwt\",\"atlassian-shape.db6bbbb6.js\",\"J9B3K\",\"custom-theme.1ca10241.js\",\"4zp3T\",\"cs.f738bfe5.js\",\"lDs9X\",\"da.6c8b9d2c.js\",\"lJNEL\",\"de.d766d160.js\",\"7UxPo\",\"en_GB.a0a38d6e.js\",\"cVGIp\",\"en_ZZ.8d2294c4.js\",\"kH9DA\",\"es.9ae576c0.js\",\"cbkwA\",\"fi.527784fa.js\",\"1xrqJ\",\"fr.a883b7ab.js\",\"8PwiF\",\"hu.9cc60e4c.js\",\"9REdC\",\"it.ebfca7f5.js\",\"bSFfJ\",\"ja.9f2a18fc.js\",\"aoOBZ\",\"ko.7eb7964a.js\",\"fWwSy\",\"nb.d7e99cbf.js\",\"4P6NK\",\"nl.883e973c.js\",\"8tp99\",\"pl.11e9cd2c.js\",\"5isBg\",\"pt_BR.8862cecf.js\",\"77Xeq\",\"ru.c63bd0f4.js\",\"fjXkb\",\"sv.eef27646.js\",\"5ppN6\",\"th.87fed470.js\",\"2ZZAw\",\"tr.123c6533.js\",\"8obpi\",\"uk.5b39c296.js\",\"ceexF\",\"vi.d8617b98.js\",\"acFsG\",\"zh_TW.e226714d.js\",\"leOLb\",\"zh.734db8b8.js\",\"dfmLT\",\"link-picker.85b3f34e.js\",\"jJErI\",\"atlassian-light.746fef94.js\",\"kHUaT\",\"atlassian-light-future.da150a84.js\",\"58XlH\",\"atlassian-light-increased-contrast.0434d02a.js\",\"e5N8r\",\"atlassian-dark.492ff2bd.js\",\"et9pQ\",\"atlassian-dark-future.6ad64b3e.js\",\"59n6H\",\"atlassian-dark-increased-contrast.8fbe5b45.js\",\"cMR7Q\",\"atlassian-legacy-light.bfd3dd30.js\",\"6eK6o\",\"atlassian-legacy-dark.c97dbe61.js\",\"2O4y4\",\"atlassian-spacing.3cd7ffc9.js\",\"ijOpK\",\"atlassian-typography.121d1ea2.js\",\"9ESKA\",\"atlassian-shape.9422a7b9.js\",\"1uftv\",\"custom-theme.065ecf04.js\",\"3kYzk\",\"atlassian-light.b97e8c08.js\",\"4SBrD\",\"atlassian-light-future.bf17f761.js\",\"9JjvF\",\"atlassian-light-increased-contrast.cb2fc9b9.js\",\"aVUKw\",\"atlassian-dark.ea9e5c1f.js\",\"8wzVE\",\"atlassian-dark-future.93f9f0f2.js\",\"40kuy\",\"atlassian-dark-increased-contrast.848b4351.js\",\"aZlu4\",\"atlassian-legacy-light.a76113a0.js\",\"8h6aK\",\"atlassian-legacy-dark.1cd23a8d.js\",\"bNFL7\",\"atlassian-spacing.29e3aab9.js\",\"jSqFG\",\"atlassian-typography.e0775138.js\",\"9RdKm\",\"atlassian-shape.2b470431.js\",\"cwdbI\",\"custom-theme.6eb0c2e8.js\",\"ltlXq\",\"body.fa2fc6e5.js\",\"48QfK\",\"esm.2801be73.js\",\"gPZkX\",\"sha256SimpleHasher.5feb4897.js\",\"fuffb\",\"sha256SimpleHasher.f4bddd9d.js\",\"fKM6M\",\"simpleHasher.e0a2f914.js\",\"lS4iW\",\"mobile-upload.bef1eb56.js\",\"6pCA8\",\"mobile-upload.6490a86a.js\",\"aFNpo\",\"browser.c821ad14.js\",\"faL9r\",\"atlassian-light.17295c6b.js\",\"bThcZ\",\"atlassian-light-future.22ed36bb.js\",\"jgp9Y\",\"atlassian-light-increased-contrast.e7224762.js\",\"fuD86\",\"atlassian-dark.1ecb3be1.js\",\"6tdv9\",\"atlassian-dark-future.37b33f52.js\",\"5sIHz\",\"atlassian-dark-increased-contrast.7b062761.js\",\"ikR9S\",\"atlassian-legacy-light.9d2f16ba.js\",\"5A7oE\",\"atlassian-legacy-dark.f184c9bc.js\",\"kOg9x\",\"atlassian-spacing.b99a586a.js\",\"d1QZr\",\"atlassian-typography.9a08532f.js\",\"8fB1m\",\"atlassian-shape.84e13851.js\",\"9xWHS\",\"custom-theme.8f9542c2.js\",\"9QHWX\",\"cardWithMediaClient.3841d346.js\",\"lgIW5\",\"js.7d8a9e0a.js\",\"brZAs\",\"png-chunks-extract.043fa34d.js\",\"euEhh\",\"mediaInline.259f6c29.js\",\"kSEDB\",\"windowedCodeBlock.d1281fb9.js\",\"4oYI8\",\"block.88d3c038.js\",\"eeJ21\",\"block.458fe71d.js\",\"5NFw4\",\"refractor.4f8ca642.js\",\"hMjIy\",\"windowedCodeBlock.84b7cc56.js\",\"7t7VP\",\"codeBlock.353d1227.js\",\"3PUK1\",\"taskList.1f4ab417.js\",\"acB4n\",\"taskItem.982a6fe2.js\",\"f6DgT\",\"taskItem.e8fea10f.js\",\"cQBGj\",\"decisionList.67daf39e.js\",\"9FoVh\",\"decisionItem.495349f0.js\",\"3biLQ\",\"date.e4a6bc7c.js\",\"h95CX\",\"status.9a8d0138.js\",\"cYMOh\",\"emoji.7207392f.js\",\"7Lbuq\",\"atlassian-light.9cbb4c46.js\",\"70Xzf\",\"atlassian-light-future.2289fe42.js\",\"7vLwj\",\"atlassian-light-increased-contrast.c45fccb5.js\",\"gdxOf\",\"atlassian-dark.be47ca06.js\",\"e6GIv\",\"atlassian-dark-future.bc26599d.js\",\"dcNlt\",\"atlassian-dark-increased-contrast.c20e34dd.js\",\"lEZ5c\",\"atlassian-legacy-light.e62ecbfe.js\",\"8sT7M\",\"atlassian-legacy-dark.f0423acb.js\",\"25MQd\",\"atlassian-spacing.7020d068.js\",\"7N1j7\",\"atlassian-typography.51f824f5.js\",\"5Nebg\",\"atlassian-shape.10a40d7e.js\",\"8krYg\",\"custom-theme.0828740a.js\",\"lAV1e\",\"panel.0ca8b071.js\",\"1B7Gg\",\"embedCard.8220d04f.js\",\"53c1I\",\"blockCard.0383370d.js\",\"3ybiy\",\"datasourceTableView.ffe92159.js\",\"fuHSb\",\"inlineCard.d5bcd026.js\",\"jgcY4\",\"datasourceRenderFailedAnalyticsWrapper.c33c5acf.js\",\"j8ne8\",\"embedCard.6c1a49e6.js\",\"lSyuz\",\"component-lazy.1b8340b4.js\",\"h0m3X\",\"audio-icon.89b25929.js\",\"5MTnN\",\"angle-brackets-icon.4feb3ff0.js\",\"joYbk\",\"folder-icon.19a5dbb0.js\",\"lalkF\",\"image-icon.7a253678.js\",\"6oF2d\",\"video-icon.565e9ec4.js\",\"5gOEa\",\"lock-locked--lock-filled.7f902e3d.js\",\"3o0pf\",\"24.736575e3.js\",\"5BU3O\",\"24.fbe63035.js\",\"3Vtk4\",\"24.87085056.js\",\"3YZy9\",\"24.b80b68bc.js\",\"7WbIj\",\"24.75b60b38.js\",\"eUDKG\",\"24.b205f8e3.js\",\"2P2t2\",\"24.c83aad24.js\",\"dbVND\",\"24.65528a80.js\",\"5cevN\",\"24.67cb388e.js\",\"idwKF\",\"24.beed740b.js\",\"jBDBf\",\"24.b6089683.js\",\"garab\",\"24.80dc3cee.js\",\"kA15Q\",\"24.8071f806.js\",\"aZqy1\",\"confluence-icon.343249cc.js\",\"9SHWr\",\"jira-icon.a73d2fe1.js\",\"36ooX\",\"attachment.e157d2d4.js\",\"ehVjG\",\"task.4b2d85c7.js\",\"iNg9c\",\"component.a96e9f4c.js\",\"ToOlT\",\"comment.177fb1da.js\",\"5DPYi\",\"eye-open--watch.8d7a89cd.js\",\"aJpEe\",\"thumbs-up--like.33b476af.js\",\"8yHD5\",\"arrow-up.aa063652.js\",\"fPbsM\",\"question-circle--question.ff3eb28a.js\",\"4ivcO\",\"angle-brackets--code.38a9647a.js\",\"1pkve\",\"people-group--people.d3f203a9.js\",\"l6fcu\",\"subtasks--subtask.e3308c06.js\",\"bbdre\",\"goal-icon.e13ce5e3.js\",\"j4IS4\",\"projects-icon.081d8fd9.js\",\"bWl0R\",\"manual-triggers-modal.ec2ea3f6.js\",\"bhpAJ\",\"manual-triggers-modal.4d6a44a8.js\",\"iQ1BA\",\"RelatedLinksModal.309496f7.js\",\"053cf\",\"EmbedModal.1e944357.js\",\"lcZFf\",\"custom-theme.80505d51.js\",\"eZm2h\",\"atlassian-light.51e17e97.js\",\"jYZcQ\",\"atlassian-light-future.4d3cdb14.js\",\"5zK6v\",\"atlassian-light-increased-contrast.f80efc07.js\",\"kAYrf\",\"atlassian-dark.f2d3df90.js\",\"ftXjB\",\"atlassian-dark-future.e79cc2c8.js\",\"dG5Lk\",\"atlassian-dark-increased-contrast.ad066eec.js\",\"6WgiH\",\"atlassian-legacy-light.b5db4dae.js\",\"50slF\",\"atlassian-legacy-dark.7ac0a777.js\",\"4YHPB\",\"atlassian-spacing.38caa0bb.js\",\"gTefI\",\"atlassian-typography.cc4419fc.js\",\"1EZt6\",\"atlassian-typography-adg3.d8204fbf.js\",\"c5XTC\",\"atlassian-shape.e6b2c9b7.js\",\"jLjAZ\",\"atlassian-shape-rounder.653bde64.js\",\"8Utct\",\"atlassian-shape-roundest.b4c19a45.js\",\"f9Kcs\",\"atlassian-typography-modernized.61cded33.js\",\"bQJhR\",\"atlassian-typography-refreshed.0e2e48ed.js\",\"6p1nh\",\"atlassian-light-brand-refresh.c208f032.js\",\"9yzVz\",\"atlassian-dark-brand-refresh.720ffdec.js\",\"6ZkQJ\",\"media.229d4cd9.js\",\"hlQ03\",\"cardWithMediaClient.249754fd.js\",\"bzzM4\",\"cardWithMediaClient.70995f97.js\",\"izQZs\",\"cardWithMediaClient.93e50ae0.js\",\"8UQ7f\",\"mediaInline.5b06c35d.js\",\"hJYnA\",\"media-viewer-error-boundary.79136603.js\",\"6WwOp\",\"sha256SimpleHasher.09f0cabd.js\",\"38fTI\",\"simpleHasher.dd83a52e.js\",\"2TJ5h\",\"simpleHasher.23d66259.js\",\"97CW7\",\"mobile-upload.a902f544.js\",\"6utrM\",\"archive.ca4385a0.js\",\"jAXsS\",\"archive.1cf35242.js\",\"jV8HR\",\"archive.cb64c212.js\",\"bGUAd\",\"codeViewerRenderer.15a82fe5.js\",\"hLPOa\",\"image.1374c2fa.js\",\"bzau0\",\"video.d1415c92.js\",\"htcL4\",\"video.554d3dbb.js\",\"zHa9m\",\"mobile-upload.09e450ed.js\",\"7np7S\",\"sha256SimpleHasher.f5e074f5.js\",\"fbUxk\",\"simpleHasher.e0d8febf.js\",\"ebte3\",\"audio.1cc469de.js\",\"043rC\",\"doc.6d650142.js\",\"auLb3\",\"codeViewer.fec9e307.js\",\"6VMUa\",\"codeViewer.3347e0c1.js\",\"bttaS\",\"dist.7eab3c01.js\",\"1OvQm\",\"dist.57c04198.js\",\"6Kt0L\",\"dist.0e91ef4a.js\",\"01GtD\",\"dist.3089f173.js\",\"1KljQ\",\"dist.ae556c7d.js\",\"23D1K\",\"dist.8ef23156.js\",\"5sBDe\",\"dist.b2746b9e.js\",\"cfsIz\",\"dist.a4a6a72b.js\",\"goUFM\",\"dist.16f85357.js\",\"bhDxP\",\"dist.89bf6462.js\",\"i6Fxq\",\"dist.93d96ff0.js\",\"7euOy\",\"dist.9c3e3b0f.js\",\"fIdB5\",\"dist.d687de3b.js\",\"poOsA\",\"dist.e0df667d.js\",\"fJOYa\",\"dist.31e1e762.js\",\"inNnj\",\"dist.6a89c4fc.js\",\"f8nMc\",\"dist.d43dc77e.js\",\"8aWee\",\"dist.91bd0a9a.js\",\"ekyBH\",\"dist.48075a60.js\",\"10xwl\",\"dist.12ce7eb7.js\",\"4p2if\",\"apl.719909bc.js\",\"dBhHg\",\"asciiarmor.ebe7e0aa.js\",\"2wZ9C\",\"asn1.902d6bf5.js\",\"da8IW\",\"asterisk.4d602718.js\",\"8oHtT\",\"brainfuck.c72214f2.js\",\"lFgtK\",\"cobol.01d61486.js\",\"cD5nw\",\"clike.971fc00e.js\",\"iDLPx\",\"clojure.8abb50aa.js\",\"44L7z\",\"css.aa1c4df5.js\",\"h3KkC\",\"cmake.7cd9222f.js\",\"51cli\",\"coffeescript.2d8564f4.js\",\"8StR8\",\"commonlisp.4f1b7e46.js\",\"6k3av\",\"cypher.05a10d7a.js\",\"imTMZ\",\"python.cdb154e3.js\",\"8LylS\",\"crystal.5ed48342.js\",\"24N01\",\"d.2b125a37.js\",\"hYP4d\",\"diff.a01f6b2f.js\",\"qM2T1\",\"dockerfile.89776102.js\",\"bLKFw\",\"dtd.8ecf97a8.js\",\"dbq97\",\"dylan.bb403715.js\",\"fGgZv\",\"ebnf.e2bd8c2c.js\",\"85Tc7\",\"ecl.96889364.js\",\"19diC\",\"eiffel.19ab7892.js\",\"aE8L0\",\"elm.cec5b216.js\",\"1OUqX\",\"erlang.2ee09c1b.js\",\"iwfY1\",\"sql.03d6e033.js\",\"UoFo6\",\"factor.6e7abfb5.js\",\"6Kdlc\",\"fcl.e1bcd65c.js\",\"iKykS\",\"forth.b898ac59.js\",\"gqg57\",\"fortran.18134af4.js\",\"iWmK9\",\"mllike.bc1fbe38.js\",\"dDto5\",\"gas.b6db8a93.js\",\"3B9QV\",\"gherkin.20e5cf67.js\",\"9GLE4\",\"groovy.02361430.js\",\"dJQax\",\"haskell.7dd3c6d6.js\",\"e7hU8\",\"haxe.5e97758d.js\",\"9q3vN\",\"http.bde10f65.js\",\"fOtJf\",\"idl.8ef8fb6a.js\",\"cVueU\",\"javascript.9e3ddc5c.js\",\"2n0nj\",\"jinja2.023111d4.js\",\"6gSx2\",\"julia.38d299e1.js\",\"jN9l6\",\"livescript.78e0e744.js\",\"c8qRK\",\"lua.84467f4b.js\",\"3AND5\",\"mirc.af7c1eae.js\",\"b2cLX\",\"mathematica.da85df21.js\",\"ZMHeR\",\"modelica.89d81239.js\",\"21nuu\",\"mumps.66395b0f.js\",\"3thkD\",\"mbox.c28ba73c.js\",\"hjATh\",\"nginx.4ff33dda.js\",\"hP1RP\",\"nsis.c5d7b2b6.js\",\"e3Tvg\",\"ntriples.a5eccd27.js\",\"cuS8X\",\"octave.1be8cfc4.js\",\"hsUFD\",\"oz.ae8f895e.js\",\"isxJL\",\"pascal.dbf6af8f.js\",\"9ewuc\",\"perl.07d28233.js\",\"5Jsj3\",\"pig.0b6d458d.js\",\"1sko9\",\"powershell.3413a33a.js\",\"lVfki\",\"properties.5f9304c6.js\",\"jDcjw\",\"protobuf.6136a465.js\",\"731OY\",\"pug.4183d1bb.js\",\"d8uo8\",\"puppet.08944df9.js\",\"3l4vo\",\"q.9208a6e1.js\",\"kAUdd\",\"r.3c77aad5.js\",\"86Yhc\",\"rpm.5b062915.js\",\"9O5VG\",\"ruby.2e56ede5.js\",\"4g5gT\",\"sas.8d9b011f.js\",\"i8z7Z\",\"scheme.874f1f5c.js\",\"aY3nK\",\"shell.73d6d78a.js\",\"02obJ\",\"sieve.ba9e9ad9.js\",\"kjCZL\",\"smalltalk.a1c7b980.js\",\"egMAQ\",\"solr.c89e4740.js\",\"4iT61\",\"sparql.3f1adec9.js\",\"dHap4\",\"spreadsheet.9c9dea40.js\",\"kUJcJ\",\"stylus.f2a48a3f.js\",\"do6Wl\",\"swift.732fe965.js\",\"2APaA\",\"stex.9932ae64.js\",\"3e71W\",\"verilog.9a963201.js\",\"kUsBB\",\"tcl.5d1f72b2.js\",\"4tgAb\",\"textile.d5839d2f.js\",\"jg4Z2\",\"tiddlywiki.1c244fc9.js\",\"6x548\",\"tiki.de574960.js\",\"c4c6S\",\"toml.dcc96ab6.js\",\"gXiWJ\",\"troff.064742e9.js\",\"bz8sX\",\"ttcn.9b87cf0a.js\",\"4Q9cH\",\"ttcn-cfg.c8ed0508.js\",\"dCV7Q\",\"turtle.6dbe0b69.js\",\"e6cuf\",\"webidl.79f951b3.js\",\"6TqOb\",\"vb.a1fb0951.js\",\"eiHCt\",\"vbscript.f67c765c.js\",\"8Yvby\",\"velocity.ddfbaa4b.js\",\"1fTqC\",\"vhdl.91154417.js\",\"1Y4ow\",\"xquery.060e285a.js\",\"6rGto\",\"yacas.3eaa07e4.js\",\"bceUd\",\"z80.b8b15d50.js\",\"jxhBg\",\"mscgen.9b54287d.js\",\"2Vlxp\",\"dist.a8807ba5.js\",\"hTW6s\",\"dist.caf6dcad.js\",\"8oZD1\",\"svg.c783099e.js\",\"5lfkC\",\"svg.8115bba7.js\",\"cpe2g\",\"media-viewer-error-boundary.25ae6bc1.js\",\"944qR\",\"media-viewer-error-boundary.b9affcd4.js\",\"7XVbH\",\"custom-theme.7553428b.js\",\"guycR\",\"atlassian-light.6e3a6ed8.js\",\"koMGO\",\"atlassian-light-future.4a892dd1.js\",\"j9NnK\",\"atlassian-light-increased-contrast.fec8986d.js\",\"8wWQp\",\"atlassian-dark.334eb04c.js\",\"kK7hv\",\"atlassian-dark-future.0aa35613.js\",\"cxiiW\",\"atlassian-dark-increased-contrast.a2720f3a.js\",\"8KTu8\",\"atlassian-legacy-light.c96d3134.js\",\"80QC9\",\"atlassian-legacy-dark.28a07581.js\",\"jb2En\",\"atlassian-spacing.0cbfc0f6.js\",\"6edK1\",\"atlassian-typography.928230e9.js\",\"k9ayx\",\"atlassian-shape.f727be2b.js\",\"asYBQ\",\"mobile-upload.89f24023.js\",\"iOYmR\",\"sha256SimpleHasher.426c87a6.js\",\"kGqXF\",\"simpleHasher.b9cf04d3.js\",\"ljcvX\",\"media.c728900f.js\",\"8UV89\",\"mobile-upload.e96b250b.js\",\"d5mCu\",\"sha256SimpleHasher.90b3a22a.js\",\"dNthE\",\"simpleHasher.b4f4ad7c.js\",\"jcR9G\",\"custom-theme.97382211.js\",\"lr62D\",\"atlassian-light.20a8138b.js\",\"f0syU\",\"atlassian-light-future.52cebc93.js\",\"lNabo\",\"atlassian-light-increased-contrast.c8550669.js\",\"5fGYU\",\"atlassian-dark.0d239760.js\",\"fzJEZ\",\"atlassian-dark-future.aa40baaa.js\",\"kexuZ\",\"atlassian-dark-increased-contrast.b8b4ec94.js\",\"fvI5P\",\"atlassian-legacy-light.c7d31c82.js\",\"4IEOH\",\"atlassian-legacy-dark.5ae0928c.js\",\"f5Ybm\",\"atlassian-spacing.f23369a5.js\",\"JggFT\",\"atlassian-typography.87d4a0ff.js\",\"234Zi\",\"atlassian-shape.21fb6124.js\",\"2QqfK\",\"inlinePlayer.ef2c6924.js\",\"20ihC\",\"sha256SimpleHasher.c22d96b2.js\",\"12k3G\",\"simpleHasher.871cf40b.js\",\"9rE5q\",\"mobile-upload.f6f88ec3.js\",\"afp8c\",\"mediaGroup.7023daec.js\",\"fKug8\",\"mediaInline.ef26b1be.js\",\"18GuL\",\"esm.7c1248ff.js\",\"QIw1s\",\"mediaInlineCard.f86441d4.js\",\"e5DOm\",\"mediaInlineAnalyticsErrorBoundary.4b306156.js\",\"9aZ5M\",\"mediaInline.4ea1497f.js\",\"it8iU\",\"sha256SimpleHasher.46422552.js\",\"l9mlb\",\"simpleHasher.a09adb10.js\",\"5snL9\",\"mobile-upload.c8351e73.js\",\"9eaWf\",\"sha256SimpleHasher.38e3cbf6.js\",\"l1xz2\",\"simpleHasher.15586120.js\",\"cziOs\",\"mediaSingle.28b487f9.js\",\"crSct\",\"mention.7cbe6dd6.js\",\"jzhjt\",\"mention.5b9e6152.js\",\"1HxWa\",\"cs.8a4bf1f8.js\",\"31AZy\",\"da.a1f02253.js\",\"iHaOG\",\"de.e6e3b988.js\",\"lAeY6\",\"en.ed60a6dc.js\",\"kndgx\",\"en_GB.f5a04541.js\",\"bcVAn\",\"en_ZZ.7c170596.js\",\"gJwZN\",\"es.c51ae7f1.js\",\"38gbK\",\"et.76796840.js\",\"kvcKj\",\"fi.21f02aae.js\",\"7m2z1\",\"fr.1e060edd.js\",\"lXSKI\",\"hu.20f4acb6.js\",\"bOwv9\",\"is.46e652b7.js\",\"bQuYd\",\"it.a12ea928.js\",\"3wiTB\",\"ja.8fe0c21c.js\",\"ax3N6\",\"ko.da36a419.js\",\"8Oko1\",\"nb.c3c6f866.js\",\"23DF8\",\"nl.d7b25000.js\",\"cT9Lk\",\"pl.aa064f0f.js\",\"1ErJf\",\"pt_BR.7a9e049a.js\",\"d9Ufj\",\"pt_PT.30a7b77f.js\",\"kNjdB\",\"ro.a9157707.js\",\"leNQu\",\"ru.45909050.js\",\"jyQ1P\",\"sk.b1934998.js\",\"kRYc4\",\"sv.31607193.js\",\"l8Gaq\",\"th.de58ce92.js\",\"2PFqk\",\"tr.0992b9a3.js\",\"asdIR\",\"uk.4c93d466.js\",\"6Wvi1\",\"vi.78ace5ec.js\",\"igYVg\",\"zh_TW.e4a54528.js\",\"2hiIW\",\"zh.cbeb4915.js\",\"fQr2e\",\"main.c8a9de20.js\",\"uAkz7\",\"atlassian-light.1a770bea.js\",\"flurl\",\"atlassian-light-future.4ef4dccb.js\",\"gSBE5\",\"atlassian-light-increased-contrast.c6a4885d.js\",\"wSAs8\",\"atlassian-dark.34274bd7.js\",\"izKyn\",\"atlassian-dark-future.f1f275ac.js\",\"2kQBd\",\"atlassian-dark-increased-contrast.862490e0.js\",\"eUvxy\",\"atlassian-legacy-light.f54fb271.js\",\"4Dw0O\",\"atlassian-legacy-dark.9c3469ac.js\",\"6k8n1\",\"atlassian-spacing.574e1635.js\",\"6e0bI\",\"atlassian-typography.6302ca7e.js\",\"63AbA\",\"atlassian-shape.511ad914.js\",\"7HiN5\",\"custom-theme.414dfe11.js\",\"5jLNe\",\"main.dc34e961.js\",\"51Wri\",\"atlassian-light.1362dc5d.js\",\"efC7W\",\"atlassian-light-future.39bb7d5c.js\",\"fK5l6\",\"atlassian-light-increased-contrast.ed9ae7ac.js\",\"6wYXz\",\"atlassian-dark.e9c67507.js\",\"3vKFU\",\"atlassian-dark-future.3ddb2974.js\",\"lm4NP\",\"atlassian-dark-increased-contrast.74d40602.js\",\"gUaBF\",\"atlassian-legacy-light.7bbcf79c.js\",\"fp1Ti\",\"atlassian-legacy-dark.974459a2.js\",\"hHBgS\",\"atlassian-spacing.046bcf43.js\",\"4lJrm\",\"atlassian-typography.f9085d9b.js\",\"gkuHl\",\"atlassian-shape.8e93ad5e.js\",\"gXiCn\",\"custom-theme.da6d46bc.js\",\"g6bWB\",\"custom-theme.bd792f62.js\",\"3kHPc\",\"atlassian-light.027a506d.js\",\"isUP9\",\"atlassian-light-future.2258fdfa.js\",\"q4kuS\",\"atlassian-light-increased-contrast.6f1a0d2c.js\",\"7J6nl\",\"atlassian-dark.d17fe6be.js\",\"58af4\",\"atlassian-dark-future.73e68b10.js\",\"gp9rG\",\"atlassian-dark-increased-contrast.7dadf710.js\",\"9QjRE\",\"atlassian-legacy-light.0c56b7cb.js\",\"fr9v1\",\"atlassian-legacy-dark.b125d0e1.js\",\"eiMcj\",\"atlassian-spacing.0ffc2e2a.js\",\"8RTRv\",\"atlassian-typography.c084d4e6.js\",\"1GJ7X\",\"atlassian-shape.f4482b2a.js\",\"f7uvI\",\"custom-theme.74d5834a.js\",\"i98AW\",\"atlassian-light.7059af2c.js\",\"8ejyL\",\"atlassian-light-future.40d0d76d.js\",\"8Zie0\",\"atlassian-light-increased-contrast.ff22d671.js\",\"3yvdq\",\"atlassian-dark.afacbf03.js\",\"KH0AF\",\"atlassian-dark-future.3a0348b9.js\",\"2zaeK\",\"atlassian-dark-increased-contrast.80ce16b7.js\",\"f4VuJ\",\"atlassian-legacy-light.75efbc2a.js\",\"19He1\",\"atlassian-legacy-dark.5dcac6b4.js\",\"2DPnE\",\"atlassian-spacing.4e5f7d29.js\",\"8FY9q\",\"atlassian-typography.02232fea.js\",\"7xyDr\",\"atlassian-shape.960ea068.js\",\"fCdeh\",\"AgentProfileCard.539d1b37.js\",\"iAd6M\",\"auto-dev.6f4556ed.js\",\"hZ56t\",\"auto-fix.47bd0a07.js\",\"9Q9B7\",\"auto-review.a2b20d71.js\",\"kyZNm\",\"backlog-buddy.d7cd766a.js\",\"cW2Sl\",\"comms-crafter.eb869be0.js\",\"dPmlZ\",\"culture.d0aadf0a.js\",\"ff2ox\",\"customer-insight.e40158cb.js\",\"lyT49\",\"decision-director.0af2a88e.js\",\"g8ELo\",\"feature-flag-avatar.4169a683.js\",\"2KQUN\",\"generic-avatar.b423870b.js\",\"5fVAX\",\"hire-writer.d9f4fe8e.js\",\"Ol8P7\",\"marketing-message-maestro.5a5567a0.js\",\"b5bBG\",\"my-user-manual.c7314707.js\",\"gkbjq\",\"okr-oracle.2d361e5f.js\",\"7aitr\",\"ops-agent.ed3e70c0.js\",\"4I8sx\",\"pitch-perfector.a43b52a1.js\",\"ivXfZ\",\"product-requirement.99d4a8a4.js\",\"C2UU7\",\"release-notes.497c3530.js\",\"ARR1a\",\"research-scout.5b1c7eaa.js\",\"jrUTw\",\"rovo-dev.e166a729.js\",\"7ByjE\",\"social-media-scribe.7e33505f.js\",\"bGLjm\",\"team-connection.f8bda224.js\",\"7MGbX\",\"workflow-builder.1d9bb588.js\",\"fqNh3\",\"trial-guide.f9896b45.js\",\"hL5ii\",\"jsm-rovo-service-agent.99a5f582.js\",\"9TO5A\",\"atlassian-light.e3bd660a.js\",\"aCUBl\",\"atlassian-light-future.cb7930c4.js\",\"d5lqz\",\"atlassian-light-increased-contrast.7eb6b2fd.js\",\"b2DpM\",\"atlassian-dark.632b26fa.js\",\"denSl\",\"atlassian-dark-future.0ab087a2.js\",\"7Uh8G\",\"atlassian-dark-increased-contrast.18e15365.js\",\"dxA4b\",\"atlassian-legacy-light.c7482cda.js\",\"5MwrP\",\"atlassian-legacy-dark.ca16a250.js\",\"fejei\",\"atlassian-spacing.bff73a68.js\",\"2A6M6\",\"atlassian-typography.727e2c00.js\",\"kqVMc\",\"atlassian-shape.b50c9e18.js\",\"2Clnz\",\"custom-theme.a9ed3846.js\",\"ltkH8\",\"atlassian-light.81ae240e.js\",\"aTP6C\",\"atlassian-light-future.b135638c.js\",\"axyPT\",\"atlassian-light-increased-contrast.397c0775.js\",\"2Wrfq\",\"atlassian-dark.fbdcc02d.js\",\"163n3\",\"atlassian-dark-future.057162d7.js\",\"hJaqH\",\"atlassian-dark-increased-contrast.659f39d7.js\",\"d9iTl\",\"atlassian-legacy-light.f89f0f7d.js\",\"2sIF4\",\"atlassian-legacy-dark.0a7bf63b.js\",\"2lFCW\",\"atlassian-spacing.97f4dba2.js\",\"fmrSF\",\"atlassian-typography.abbb53df.js\",\"5ssKb\",\"atlassian-shape.e099aa40.js\",\"7gzT7\",\"custom-theme.7afba597.js\",\"5kEP7\",\"atlassian-light.d6a0c002.js\",\"bI8t1\",\"atlassian-light-future.8d2e78f7.js\",\"8wyJM\",\"atlassian-light-increased-contrast.37bd386c.js\",\"ctSKB\",\"atlassian-dark.aa35dece.js\",\"cwUH6\",\"atlassian-dark-future.81ccdcbe.js\",\"76otm\",\"atlassian-dark-increased-contrast.bca951a1.js\",\"gAvZB\",\"atlassian-legacy-light.0d5cc017.js\",\"4AtXk\",\"atlassian-legacy-dark.5dabb4f7.js\",\"2b2vq\",\"atlassian-spacing.2eb8390a.js\",\"gdnmr\",\"atlassian-typography.dc90b6c0.js\",\"lgqVc\",\"atlassian-shape.c20db845.js\",\"f8UHw\",\"custom-theme.66d41d6c.js\",\"9X463\",\"AgentProfileCard.a0fc2356.js\",\"iWCiw\",\"AgentProfileCard.b4efb5cc.js\",\"i9RPe\",\"ProfileCard.8852aef1.js\",\"hYL0Z\",\"atlassian-light.bf5bb151.js\",\"bSaOj\",\"atlassian-light-future.4425d200.js\",\"bRfnK\",\"atlassian-light-increased-contrast.e7cf9f45.js\",\"7dMDX\",\"atlassian-dark.6751f6fc.js\",\"izqHZ\",\"atlassian-dark-future.a9de482e.js\",\"eHm2F\",\"atlassian-dark-increased-contrast.c9c8e8f2.js\",\"jim0m\",\"atlassian-legacy-light.a029aabb.js\",\"5VlaR\",\"atlassian-legacy-dark.894faee0.js\",\"l5zDQ\",\"atlassian-spacing.fe7ee361.js\",\"h4XkJ\",\"atlassian-typography.9354f26a.js\",\"HM0lG\",\"atlassian-shape.8ac43303.js\",\"iD5RU\",\"custom-theme.9bea7d2e.js\",\"8sead\",\"Expand.09489b6d.js\",\"gj6MI\",\"syncBlock.7ebe0576.js\",\"3lLZB\",\"bodiedSyncBlock.6a5ef1bd.js\",\"7Q4ht\",\"view.557db1bb.js\",\"gFcxC\",\"view.74b26cde.js\",\"9WEDO\",\"view.0a064cfd.js\",\"HRjDP\",\"esm.b096b249.js\",\"6zKN2\",\"chat-widget-omni-channel-ui.b2945695.js\",\"j2nJQ\",\"esm.5bf5af8a.js\",\"cXOXe\",\"custom-theme.68de502a.js\",\"6gTh3\",\"atlassian-light.bf5bfc93.js\",\"dDmTi\",\"atlassian-light-future.6e8718c6.js\",\"16zvp\",\"atlassian-light-increased-contrast.6a44198f.js\",\"3dz69\",\"atlassian-dark.f9a4c51f.js\",\"k8DtJ\",\"atlassian-dark-future.0dbcfc3a.js\",\"jtSSZ\",\"atlassian-dark-increased-contrast.fa80c22c.js\",\"eoqiN\",\"atlassian-legacy-light.e2cc5164.js\",\"czZoh\",\"atlassian-legacy-dark.de6d9fb0.js\",\"jExvY\",\"atlassian-spacing.1d8acecf.js\",\"9njwY\",\"atlassian-typography.23933777.js\",\"ePzeI\",\"atlassian-shape.50a06946.js\",\"8qSAx\",\"esm.80e059d1.js\",\"gjBTD\",\"media.72a66607.js\",\"eDmkW\",\"mention.917b4896.js\",\"1UZeW\",\"chat-widget-omni-channel-ui.e5c155f5.js\",\"hx68B\",\"chat-widget-customer-analytics.ee46278f.js\"]"));


//# sourceMappingURL=jira-product-discovery-page.0a9eb167.js.map
